import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { history } from "../../helper/history";
import { shippingOptionsService } from "../../services/shippingOptions";
import { userService } from "../../services/user";

export const shippingOptionsActions = {
    updatePermission,
    getCustomerShippingOptions,
    storeShippingOption,
    deleteShippingOption
};

function updatePermission(userId) {
    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function() {
                    history.go(0);
                }, 500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_FAILURE,
            payload: error
        };
    }
}

function getCustomerShippingOptions(custId) {
    return dispatch => {
        dispatch({ type: adminConstants.GET_SHIPPING_OPTION_REQUEST });
        return shippingOptionsService.getShippingOptions(custId).then(
            list => {
                dispatch({
                    type: adminConstants.GET_SHIPPING_OPTION_SUCCESS,
                    payload: list
                });
            },
            error => {
                dispatch({
                    type: adminConstants.GET_SHIPPING_OPTION_FAILURE,
                    payload: error
                });
                dispatch(alertActions.error(error));
            }
        );
    };
}

function storeShippingOption(data) {
    return dispatch => {
        shippingOptionsService.storeShippingOption(data).then(
            response => {
                dispatch({ type: adminConstants.STORE_SHIPPING_OPTION_SUCCESS, payload: response });
                dispatch(alertActions.success(response.message));
            },
            error => {

            }
        )
    }
}

function deleteShippingOption(data) {
    return dispatch => {
        shippingOptionsService.deleteShippingOption(data).then(
            response => {
                dispatch(
                    { type: adminConstants.DELETE_SHIPPING_OPTION_SUCCESS, payload: response }
                );
                dispatch(alertActions.success(response.message));
            },
            error => {
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/shipping-options-actions.jsx